import React from "react";

const Footer = () => {
  return (
    <div>
      <h3>Footer</h3>
    </div>
  );
};

export default Footer;
